<template>
  <div class="insert" v-if="order">
    <div class="insert--cart">
      <div class="inner">
        <div class="row title">
          <h4>Order summary</h4>
        </div>

        <div class="insert--cart-lines">
          <div class="insert--cart-lines__header">
            <div>
              <strong>Currency</strong>
            </div>
            <div>
              <strong>Quantity</strong>
            </div>
            <div>
              <strong>Rate</strong>
            </div>
            <div>
              <strong v-if="order.product.id !== ProductTypes.SELL_BACK">Price</strong>
              <strong v-else>You'll get</strong>
            </div>
          </div>

          <div class="insert--cart-lines__items">
            <div
                 class="insert--cart-lines__item"
                 v-for="(line, index) in order.lines"
                 :key="index"
                 >
              <div class="column">
                <strong class="label">Currency</strong>
                <div class="row">
                  <div
                       :class="`icon icon__${line.currency.code.toLowerCase()}`"
                       ></div>
                  <div class="code">{{ line.currency.code }}</div>
                </div>
              </div>
              <div>
                <strong class="label">Quantity</strong>
                <span>{{ line.qty }}</span>
              </div>
              <div>
                <strong class="label">Rate</strong>
                <span>{{ line.rate | rate }}</span>
              </div>
              <div>
                <strong class="label" v-if="order.product.id !== ProductTypes.SELL_BACK"
                  >Price</strong
                >
                <strong class="label" v-else>You'll get</strong>
                <span>{{ line.total | price }}</span>
              </div>
            </div>
            <div
                 class="insert--cart-lines__buyback"
                 v-if="COMMERCE_SHOW_BUYBACK && order.buyBackGuarantee"
                 >
              <b>Buyback Guarantee</b>
              <p>{{ 4 | price }}</p>
            </div>
            <div
                 class="insert--cart-lines__buyback"
                 v-if="COMMERCE_SHOW_REFUND && order.refundGuarantee"
                 >
              <b>Refund Guarantee</b>
              <p>{{ 3 | price }}</p>
            </div>

            <div class="insert--cart-lines__buyback"
                 v-if="deliverySlot">
              <b>
                {{ deliverySlot.deliveryMethodName }}
              </b>
              <p>
                {{ deliverySlot.price | price }}
              </p>
            </div>
            <div class="insert--cart-lines__total">
                <b v-if="order.product.id !== ProductTypes.SELL_BACK">Total to pay</b>
                <b v-else>Total you will receive</b>
                <p class="total-price">{{ order.total | price }}</p>
            </div>

          </div>
        </div>
        <div class="delivery">
          <div v-if="order.deliveryAddress">
            <b v-if="order.product.id === ProductTypes.HOME_DELIVERY">Delivery Address</b>
            <b v-else>Collection Address</b>
            <delivery-address :order="order" />
          </div>          
          <div v-if="deliverySlot">
            <b v-if="order.product.id === ProductTypes.HOME_DELIVERY">Delivery Date</b>
            <b v-else>Collection Date</b>
            <div class="column">
              <span>{{ deliverySlot.date | date }}</span>             
              <div v-if="order.product.id === ProductTypes.HOME_DELIVERY && isMonday()" class="delivery-caveat">
                <span>
                  {{ `If you place an order for Monday, Royal Mail may attempt delivery on Saturday. This is beyond our
                  control. If you miss your delivery, Royal Mail will automatically arrange a redelivery for the next day.
                                    If you have the Royal Mail app you can redirect the delivery to a later date.` }}
                </span>
              </div> 
              <div v-if="order.product.id === ProductTypes.HOME_DELIVERY && hoursUntil(new Date(deliverySlot.date)) <= 24" class="delivery-caveat">
                <span v-if="content">
                  {{content.remotePostalDelayWarning || `Royal Mail requires 48 hours for delivery to certain locations in the Scottish Highlands and Islands, 
                  Northern Ireland, and Channel Islands. Please refer to the FAQ below to see if your area is affected.` }}
                </span>
              </div> 
              <div v-if="!deliverySlot.isInStock && order.product.id === ProductTypes.CLICK_AND_COLLECT" class="delivery-caveat">
                <span>
                  <strong>Free collection - available from 2pm. </strong> <br>
                  {{ 'If your order is available for collection before 2pm, we’ll contact you' }}
                </span>
              </div>
            </div>
          </div>
          
        </div>       
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import DeliveryAddress from '@vue/views/checkout/common/delivery-address'
import {
  COMMERCE_SHOW_BUYBACK,
  COMMERCE_SHOW_REFUND,
} from '@vue/common/constants/config'
import { ProductTypes } from '@vue/common/constants/productTypes'
import dateUtils from '@vue/utils/date.utils'

let isinstock = true;

export default {
  name: 'OrderSummary',
  props: {
    osisinstock: {
      type: Boolean
    },
    deliverySlot: {
      type: Object
    }
  },
  components: {
    DeliveryAddress,
  },
  data() {
    return {
      COMMERCE_SHOW_BUYBACK,
      COMMERCE_SHOW_REFUND,
      ProductTypes: ProductTypes
    }
  },
  methods: {
    isMonday() {
      if (this.deliverySlot != null && this.deliverySlot !=undefined) {
        let d = new Date(this.deliverySlot.date);
        if (d.getDay() === 1)
          return true
      }
    },
    hoursUntil(date) {
      return dateUtils.hoursUntil(date);
    },
    ...mapActions({
      getCheckoutContent: 'checkout/getCheckoutContent'
    }),
  },
  computed: {
    ...mapState('checkout', ['content', 'order']),
    store: (state) => state.store.store
  },
  async mounted() {
    this.getCheckoutContent()
  }

}
</script>
